import "./styles.scss";

import React from "react";
import { Link } from "gatsby";

const details = [
  "Spokój w Głowie sp. z o.o.",
  "NIP: 1251715547",
  "REGON: 388115171",
  "KRS: 0000890483",
];

const links = [
  {
    label: "Mapa strony",
    url: "/mapa/",
  },
  {
    label: "Reklama",
    url: "/reklama/",
  },
  {
    label: "Standardy ochrony małoletnich",
    url: "/standardy-ochrony-maloletnich/",
  },
  {
    label: "Polityka Prywatności",
    url: "/polityka-prywatnosci/",
  },
  {
    label: "Polityka Cookies",
    url: "/polityka-cookies/",
  },
];

const Info = () => {
  return (
    <div className="footer-info">
      <ul>
        {details.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
      <ul>
        {links.map((item, index) => (
          <li key={index}>
            <Link to={item.url}>{item.label}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Info;
